import styled from 'styled-components'

export const StyledTableFooterContainer = styled.div`
  .ant-form-item {
    margin: 0;
  }
`
